import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

const WelcomeDialog = ({ open, onClose, user, onPreferenceSaved }) => {
  const [saving, setSaving] = useState(false);

  const handleUnderstood = async () => {
    localStorage.setItem('welcomeModalSeen', 'true');
    if (user) {
      setSaving(true);
      try {
        const token = localStorage.getItem('token');
        const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/api/profile`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({ dontShowFilterModal: true }),
        });
        if (response.ok) {
          const updatedUser = await response.json();
          if (onPreferenceSaved) onPreferenceSaved(updatedUser);
        }
      } catch (e) {
        console.error('Не удалось сохранить настройку:', e);
      } finally {
        setSaving(false);
      }
    }
    onClose();
  };

  return (
    <Dialog
      open={open}
      onClose={() => {}}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          backgroundColor: '#F5F3F0',
        },
      }}
    >
      <DialogTitle sx={{ color: '#000000', fontWeight: 'bold', fontFamily: 'serif' }}>
        Добро пожаловать
      </DialogTitle>
      <DialogContent>
        <Typography variant="body1" sx={{ color: '#333', lineHeight: 1.6 }}>
          Вы можете выбрать центр выдачи и даты аренды в верхнем меню — это гарантирует наличие оборудования на нужные Вам даты.
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'flex-end', px: 3, pb: 2 }}>
        <Button
          onClick={handleUnderstood}
          disabled={saving}
          sx={{
            backgroundColor: '#8B7D6B',
            color: '#FFFFFF',
            fontWeight: 'bold',
            textTransform: 'none',
            '&:hover': {
              backgroundColor: '#6B5D4B',
            },
          }}
        >
          {saving ? 'Сохранение...' : 'Понятно'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default WelcomeDialog;
